import { __extends } from "tslib";
import { Point } from '@awayjs/core';
import { FilterUtils } from '../../utils/FilterUtils';
import { TaskBaseWebGL } from './webgl/TaskBaseWebgGL';
var FRAG = function (_a) {
    var _b = _a.compX, compX = _b === void 0 ? 0 : _b, _c = _a.compY, compY = _c === void 0 ? 1 : _c, _d = _a.mode, mode = _d === void 0 ? 'wrap' : _d;
    return "\nprecision highp float;\n\n// source\nuniform sampler2D fs0;\n// map\nuniform sampler2D fs1;\nuniform vec2 uMapPoint;\nuniform vec2 uScale;\n" + (mode === 'color' ? 'uniform vec4 uColor;' : '') + "\n\nvarying vec2 vUv;\nvoid main() {\n\tvec4 map = texture2D(fs1, vUv - uMapPoint);\n\tvec2 offset = vec2(map[" + (compX | 0) + "] - 0.5, map[" + (compY | 0) + "] - 0.5) * uScale; \n\n\tvec2 uv = vUv + offset;\n\n\t" + (!mode || mode === 'wrap' ? 'uv = fract(uv);' : '') + "\n\t" + (mode === 'clamp' ? 'uv = clamp(uv, 0., 1.);' : '') + "\n\t" + (mode === 'ignore' ? 'uv = vUv;' : '') + "\n\t" + (mode === 'color' ? 'float outside = step(0.5, length(uv - vec(0.5)));' : '') + "\n\n\t" + (mode === 'color'
        ? 'gl_FragColor = mix(texture2D(fs0, uv), uColor, outside);'
        : 'gl_FragColor = texture2D(fs0, uv);') + "\n}\n\n";
};
var DisplacementTask = /** @class */ (function (_super) {
    __extends(DisplacementTask, _super);
    function DisplacementTask() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.mode = 'wrap';
        _this.componentX = 1;
        _this.componentY = 2;
        _this.mapPoint = new Point(0, 0);
        _this._uColor = [0, 0, 0, 0];
        _this._color = 0x0;
        _this._alpha = 0x0;
        _this.scaleX = 1;
        _this.scaleY = 1;
        return _this;
    }
    Object.defineProperty(DisplacementTask.prototype, "color", {
        get: function () {
            return this._color;
        },
        set: function (value) {
            if (this._color === value)
                return;
            this._color = value;
            FilterUtils.colorToArray(this._color, this._alpha, this._uColor);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplacementTask.prototype, "alpha", {
        get: function () {
            return this._alpha;
        },
        set: function (value) {
            if (this._alpha === value)
                return;
            this._alpha = value;
            this._uColor[3] = this._alpha;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplacementTask.prototype, "name", {
        get: function () {
            return "Displacement:" + this.mode + ":" + this.componentX + ":" + this.componentY;
        },
        enumerable: false,
        configurable: true
    });
    DisplacementTask.prototype.getFragmentCode = function () {
        return FRAG({
            compX: Math.log2(this.componentX),
            compY: Math.log2(this.componentY),
            mode: this.mode
        });
    };
    DisplacementTask.prototype.activate = function (_stage, _projection, _depthTexture) {
        _super.prototype.computeVertexData.call(this);
        var input = this.inputRect;
        var map = this.mapBitmap;
        var p = this._program3D;
        p.uploadUniform('uTexMatrix', this._vertexConstantData);
        p.uploadUniform('uScale', [
            this.scaleX / input.width,
            this.scaleY / input.height
        ]);
        p.uploadUniform('uMapPoint', [
            this.mapPoint.x / this.mapBitmap.width,
            this.mapPoint.y / this.mapBitmap.height
        ]);
        if (this.mode === 'color') {
            p.uploadUniform('uColor', this._uColor);
        }
        this.mapBitmap.getAbstraction(_stage).activate(1);
    };
    return DisplacementTask;
}(TaskBaseWebGL));
export { DisplacementTask };
